import { Container } from 'inversify-props';
import setupSupportTicket from '@/modules/zendesk/support-ticket/setup';
import setupAnonymousTicket from '@/modules/zendesk/anonymous-ticket/setup';

export default function setupZendeskModule(container: Container) {
  setupSupportTicket(container);
  setupAnonymousTicket(container);
}
